import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const HEADERDIGITALMENUBLOCK_LEGACY_FIELD_ORDER = [];

const {
  headerDigitalMenuBlockDescriptor: _generatedHeaderDigitalMenuBlockDescriptor,
  headerDigitalMenuBlockBlocDefinition,
  headerDigitalMenuBlockDashboardLayout,
  headerDigitalMenuBlockConfig,
  headerDigitalMenuBlockResolveConfig,
  headerDigitalMenuBlockProperties,
} = doodBlockConfig(
  {
    name: "Shop digital menu - Header",
    componentType: 'HeaderDigitalMenuBlockComponent',
    category: 'navigation',
    description: "Shop digital menu - Header.",
    keywords: [],
    allowedIn: [
      { bloc: "HeaderBlockComponent", slot: "left_blocks" },
      { bloc: "HeaderBlockComponent", slot: "navigation_links" },
      { bloc: "ShopDigitalMenuPageComponent", slot: "body" },
      { bloc: "MarketplaceProductsPageComponent", slot: "body" },
      { bloc: "ShopPageComponent", slot: "body" },
    ],
    sharedFields: {}
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: [],
          },
        ],
      },
    ],
  })
);

export function headerDigitalMenuBlockDescriptor(): IBlockDescriptor;
export function headerDigitalMenuBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function headerDigitalMenuBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedHeaderDigitalMenuBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedHeaderDigitalMenuBlockDescriptor, headerDigitalMenuBlockProperties, fieldOrder);
}

export {
  headerDigitalMenuBlockBlocDefinition,
  headerDigitalMenuBlockDashboardLayout,
  headerDigitalMenuBlockProperties,
  headerDigitalMenuBlockConfig,
  headerDigitalMenuBlockResolveConfig,
};

export type HeaderDigitalMenuBlockConfig = typeof headerDigitalMenuBlockConfig;
